import React, { useState, useEffect, useRef } from 'react'
import { Modal, ModalHeader, ModalFooter, ModalBody, Button, Col, Input, Row, Spinner, Toast } from 'reactstrap'
import { useSelector } from 'react-redux';
import "../../../assets/scss/plugins/extensions/toastr.scss"
import "react-toggle/style.css"
import "react-toastify/dist/ReactToastify.css"
import "../../../assets/scss/plugins/extensions/toastr.scss"
import API from '../../../providers/api';
import moment from 'moment';
import { toast, ToastContainer } from 'react-toastify';
import { FaLink, FaPlus, FaPlusCircle } from 'react-icons/fa';

export const ModalWhatsapp = ({ showModal, setShowModal }) => {
    const idprofile = useSelector(state => state.auth.login.state.data.user.verifyLogin.idprofile)
    const [id, setId] = useState(0)
    const [email, setEmail] = useState('')
    const [applicantEmail, setApplicantEmail] = useState(null);
    const [phone, setPhone] = useState('')
    const [URL, setURL] = useState('')
    const [viewQR, setViewQR] = useState('')
    const [loading, setLoading] = useState(false)
    const [uploadFiles, setUploadFiles] = useState(null)
    const toggleModal = () => {
        setShowModal(!showModal)
    }

    const toggleClose = () => setShowModal(!showModal)

    const list = () => {
        API.loadparameter(261)
            .then(data => data.json())
            .then(dataJson => {
                if(dataJson.success){
                    setId(dataJson.data[0].id)
                    setPhone(dataJson.data[0].name)
                    setURL(dataJson.data[0].aux)
                    setViewQR(dataJson.data[0].aux2)
                }
            })
            .catch((e) => {
                console.log("Error =>", e);
            })
    }

    useEffect(() => {
        if(idprofile == 7)
            list()
    }, [])

    const saveInfo = () => {
        if(phone == ""){
            return toast.warning('Phone is required')
        }
        if(URL == ""){
            return toast.warning('URL is required')
        }
        if(uploadFiles == null || uploadFiles == ""){
            return toast.warning('File is required')
        }
        setLoading(true)
        API.uploadFileExternal(uploadFiles)
        .then(data => data.json())
        .then(dataJson => {
            if (dataJson.success === true) {
                API.saveInfoQR(id, phone, URL, dataJson.dataImg.url)
                .then(data => data.json())
                .then(dataJson => {
                    if (dataJson.success === true) {
                        list()
                        toast.success(dataJson.message)
                    } else {
                        toast.warning(dataJson.message)
                    }
                    setLoading(false)
                })
            }else{
                toast.warning(dataJson.message)
            }
        })
    }

    const validateEmail = (email) => {
        let isValidEmail = /\S+@\S+\.\S+/.test(email);
        if (!isValidEmail) {
            setApplicantEmail(false);
        } else {
            setApplicantEmail(true);
        }
    }

    const sendEmail = () => {
        if(email === ''){
            return toast.warning('Email required')
        }
        if(applicantEmail === false){
            return toast.warning('Email is invalid')
        }
        API.sendEmailContactus(email)
        .then(data => data.json())
        .then(dataJson => {
            if (dataJson.success === true) {
                toast.success(dataJson.message)
                //setShowModal(!showModal)
            } else {
                toast.warning(dataJson.message)
            }
        })
    }

    const onchangeFile = (event) => {
        setUploadFiles(event.target.files[0]);
    }

return (
<Modal isOpen={showModal} toggle={toggleClose}>
    <ModalHeader toggle={toggleClose}>
    Send contact email
    </ModalHeader>
    <ModalBody>
        {
            idprofile == 7 &&
            <>
                <Row>
                    <Col>
                        <label>Number</label>
                        <Input type="text" placeholder="Phone" value={phone} onChange={e => setPhone(e.target.value)} />
                    </Col>
                    <Col>
                        <label>URL <a href="https://crear.wa.link/" target='_blank'><FaLink size={10} color='green' /></a></label>
                        <Input type="text" placeholder="URL" value={URL} onChange={e => setURL(e.target.value)} />
                        <small>No incluir el (http:// o https://)</small>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <label>Image QR</label>
                        <Input type="file" name="uploadFile" onChange={event => onchangeFile(event)} />
                    </Col>
                    <Col>
                    {
                        loading == false ? <Button color="success" onClick={saveInfo}>Save</Button>
                        : <Spinner color='success' size={20} />
                    }
                    </Col>
                </Row>
                <Row className='mt-2'>
                    <Col className='text-center'>
                        <label>Current QR</label><br/>
                        {viewQR != "" ? <img src={viewQR} width="200" height="200" /> : null}
                    </Col>
                </Row>
            </>
        }
        <hr />
        <div
            style={{
            background: "#d1ecf1",
            border: "1px solid #bee5eb",
            borderRadius: "6px",
            padding: "12px 16px",
            marginTop: "20px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.04)",marginBottom: "20px"
            }}
        >
            <strong style={{ color: "#0c5460" }}>📌 Nota:</strong>{" "}
            <ul style={{ color: "#0c5460", fontSize: 13 }}>
                <li>Diligencie el correo electrónico del cliente para que envié la factura.</li>
                <li>Una vez enviado, confirme con el cliente la recepción del correo electrónico. Que ingrese en la bandeja de entrada o en SPAM.</li>
                <li>Manifieste que en el correo que recibió el cliente de clic en el icono de Whatsapp, para que envie la factura.</li>
            </ul>
        </div>
        <Row className='mt-2'>
            <Col lg="8">
                <label>Email
                    {
                        (email !== "" && applicantEmail === false) &&
                        <label style={{ color: "red" }}>format is invalid</label>
                    }
                </label>
                <Input type="text" placeholder="Email" value={email} onChange={e => {
                    setEmail(e.target.value);validateEmail(e.target.value)
                    }} />
            </Col>
            <Col>
                <br/>
                <Button color="success" onClick={sendEmail}>Send</Button>
            </Col>
        </Row>
    </ModalBody>
    <ModalFooter>
        <Button outline color="success" onClick={toggleModal}>Close</Button>{" "}
    </ModalFooter>
    <ToastContainer />
</Modal>
)
}
